import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Form, Button, Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import {
  DEFAULT_TRAINING_VIDEOS_PER_WEEK,
  DEFAULT_TYPE_OF_VIDEOS_KEYS,
} from '../../../constants/appConstants';
import * as action from '../../../actions/videos/trainingVideos';
import debounce from '../../../utils/debounce';

const ChangeTemplateVideos = ({
  templateVideo,
  createTemplateVideo,
  getSubtemplateTrainingVideos,
  trainingsSubtemplateList,
  changeTemplateVideo,
  searchSubtemplateVideosByName,
}) => {
  const [templateName, setTemplateName] = useState((!!templateVideo && templateVideo.name) || '');
  const [isNameNotFilled, setIsNameNotFilled] = useState(false);
  const [currentFieldIndex, setCurrentFieldIndex] = useState(0);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [isSelectNotFilled, setIsSelectNotFilled] = useState(false);
  const existingTrainingsSubpatternsListForEditing =
    !!templateVideo &&
    templateVideo.complete_course &&
    templateVideo.complete_course.map((video) => {
      if (!video) return null;
      return video.id;
    });
  const [selectedTrainingsSubpatternsList, setSelectedTrainingsSubpatternsList] = useState(
    existingTrainingsSubpatternsListForEditing || [null, null, null, null, null, null, null],
  );
  const [trainingsSubtemplateLists, setTrainingsSubtemplateLists] = useState([
    trainingsSubtemplateList,
    trainingsSubtemplateList,
    trainingsSubtemplateList,
    trainingsSubtemplateList,
    trainingsSubtemplateList,
    trainingsSubtemplateList,
    trainingsSubtemplateList,
  ]);

  const [uniqueTags, setUniqueTags] = useState([]);

  const handleTemplateName = React.useCallback(
    (e) => {
      setTemplateName(e.target.value);
      setIsNameNotFilled(false);
    },
    [setTemplateName, setIsNameNotFilled],
  );

  const handleSelectedDay = React.useCallback(
    (event, data, index) => {
      setIsSelectNotFilled(false);
      let newSelectedDaysVideos = data.value;
      if (!newSelectedDaysVideos) {
        newSelectedDaysVideos = null;
      }
      const newSelecteVideos = selectedTrainingsSubpatternsList.map(
        (subTemplate, subTemplateIndex) => {
          if (subTemplateIndex === index) {
            return newSelectedDaysVideos;
          }
          return subTemplate;
        },
      );
      setSelectedTrainingsSubpatternsList(newSelecteVideos);
    },
    [
      setSelectedTrainingsSubpatternsList,
      selectedTrainingsSubpatternsList,
      templateVideo,
      setIsSelectNotFilled,
    ],
  );

  const handleSearchSubtemplate = React.useCallback(
    (event, data, i) => {
      searchSubtemplateVideosByName(data.searchQuery);
      setCurrentFieldIndex(i);
    },
    [
      setSelectedTrainingsSubpatternsList,
      selectedTrainingsSubpatternsList,
      templateVideo,
      setIsSelectNotFilled,
    ],
  );

  const onSaveTemplateVideo = React.useCallback(
    (e) => {
      let isNameNotFill = false;
      if (!templateName) {
        setIsNameNotFilled(true);
        isNameNotFill = true;
      }
      let isSubTemplateValueFilled = false;
      selectedTrainingsSubpatternsList.map((subTemplate) => {
        if (!subTemplate) {
          setIsSelectNotFilled(true);
        } else isSubTemplateValueFilled = true;
        return null;
      });
      if (isSubTemplateValueFilled) {
        setIsSelectNotFilled(false);
      }

      if (!isNameNotFill && isSubTemplateValueFilled && !templateVideo.id) {
        createTemplateVideo({ name: templateName, subpatterns: selectedTrainingsSubpatternsList });
      } else {
        changeTemplateVideo({
          name: templateName,
          subpatterns: selectedTrainingsSubpatternsList,
          id: templateVideo.id,
        });
      }
    },
    [
      setIsNameNotFilled,
      setIsSelectNotFilled,
      createTemplateVideo,
      templateName,
      selectedTrainingsSubpatternsList,
    ],
  );

  const searchUniqueTags = React.useCallback(() => {
    const subTemplateTags = [];
    const subTemplateTagsIds = [];
    trainingsSubtemplateLists &&
      trainingsSubtemplateLists.forEach((subTemplateList) => {
        subTemplateList &&
          subTemplateList.forEach((subTemplate) => {
            selectedTrainingsSubpatternsList &&
              selectedTrainingsSubpatternsList.forEach((currentSubTemplateId) => {
                if (subTemplate && subTemplate.id === currentSubTemplateId) {
                  DEFAULT_TYPE_OF_VIDEOS_KEYS.forEach((videoType) => {
                    const subTemplateVideoValue = subTemplate.videos[videoType];
                    if (!subTemplateVideoValue) return;
                    !!subTemplateVideoValue.tags &&
                      subTemplateVideoValue.tags.forEach((tag) => {
                        if (!subTemplateTagsIds.includes(tag.tag_id)) {
                          subTemplateTagsIds.push(tag.tag_id);
                          subTemplateTags.push(tag);
                        }
                      });
                  });
                }
              });
          });
      });
    setUniqueTags(subTemplateTags);
  }, [selectedTrainingsSubpatternsList, setUniqueTags]);

  useEffect(() => {
    getSubtemplateTrainingVideos();
    searchUniqueTags();
  }, []);

  useEffect(() => {
    searchUniqueTags();
  }, [selectedTrainingsSubpatternsList]);

  useEffect(() => {
    setIsSearchLoading(true);
    const trainingsSubtemplate = trainingsSubtemplateLists[0].length
      ? trainingsSubtemplateLists
      : [
          trainingsSubtemplateList,
          trainingsSubtemplateList,
          trainingsSubtemplateList,
          trainingsSubtemplateList,
          trainingsSubtemplateList,
          trainingsSubtemplateList,
          trainingsSubtemplateList,
        ];
    templateVideo &&
      templateVideo.complete_course &&
      templateVideo.complete_course.map((video, i) => {
        if (video !== null) {
          if (trainingsSubtemplate[i].indexOf(video) !== -1) {
            return trainingsSubtemplate[i].push(video);
          }
        }
      });
    trainingsSubtemplate[currentFieldIndex] = trainingsSubtemplateList;
    setTrainingsSubtemplateLists(trainingsSubtemplate);
    setTimeout(() => {
      setIsSearchLoading(false);
    }, 0);
  }, [
    trainingsSubtemplateList,
    setTrainingsSubtemplateLists,
    trainingsSubtemplateLists,
    currentFieldIndex,
  ]);

  return (
    <ChangeTemplateVideoBlock>
      <MainTitle>Управление шаблонами видео тренировок</MainTitle>
      <Form onSubmit={(e) => onSaveTemplateVideo(e)}>
        <Form.Field error={isNameNotFilled}>
          <SelectVideosBlockName>
            <TitleOfFormField required>Имя шаблона</TitleOfFormField>
            <input
              onChange={(e) => handleTemplateName(e)}
              value={templateName}
              placeholder="Введите имя шаблона"
            />
          </SelectVideosBlockName>
        </Form.Field>
        <Form.Field error={isSelectNotFilled}>
          {DEFAULT_TRAINING_VIDEOS_PER_WEEK.map((day, i) => {
            return (
              <React.Fragment key={day}>
                <SelectVideosBlock>
                  <TitleOfFormField>{day}</TitleOfFormField>
                  <Dropdown
                    placeholder="Выберите подшаблон"
                    clearable
                    fluid
                    search
                    selection
                    loading={isSearchLoading}
                    value={selectedTrainingsSubpatternsList[i]}
                    options={trainingsSubtemplateLists[i].map((video) => {
                      return { key: video.id, text: video.name, value: video.id };
                    })}
                    onChange={(e, data) => handleSelectedDay(e, data, i)}
                    onSearchChange={debounce(
                      (e, data) => handleSearchSubtemplate(e, data, i),
                      1000,
                    )}
                  />
                </SelectVideosBlock>
              </React.Fragment>
            );
          })}
        </Form.Field>
        <Form.Field>
          <TagsContentBlock>
            <TitleOfFormField>Используемые теги</TitleOfFormField>
            <VideoTagsBlock>
              {!!uniqueTags &&
                uniqueTags.map((tag) => {
                  return <TagsTitle key={tag.tag_id}>{tag.name}</TagsTitle>;
                })}
            </VideoTagsBlock>
          </TagsContentBlock>
        </Form.Field>
        <SubmitButton>
          <Button positive type="submit">
            Сохранить
          </Button>
        </SubmitButton>
      </Form>
    </ChangeTemplateVideoBlock>
  );
};

const mapStateToProps = (state) => {
  const { templateVideo, trainingsSubtemplateList } = state.trainingVideos;

  return {
    templateVideo,
    trainingsSubtemplateList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createTemplateVideo: (templateVideo) => {
      dispatch(action.createTemplateVideo(templateVideo));
    },
    setTemplateTrainingVideos: (templateVideo) => {
      dispatch(action.setTemplateTrainingVideos(templateVideo));
    },
    getSubtemplateTrainingVideos: (page) => {
      dispatch(action.getSubtemplateTrainingVideos(page));
    },
    changeTemplateVideo: (templateVideo) => {
      dispatch(action.changeTemplateVideo(templateVideo));
    },
    searchSubtemplateVideosByName: (name) => {
      dispatch(action.searchSubtemplateVideosByName(name));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeTemplateVideos);

const MainTitle = styled.h1`
  font-size: 24px;
  text-align: center;
  padding-top: 10px;
`;

const ChangeTemplateVideoBlock = styled.div`
  width: 50%;
  margin: 0 auto;
`;

const SelectVideosBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
`;

const SelectVideosBlockName = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
`;

const TagsContentBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

const TitleOfFormField = styled.p`
  font-size: 14px;
  text-align: flex-start;
  margin-top: 10px;
  margin-bottom: 0;
  width: 140px;
`;

const TagsTitle = styled.p`
  font-size: 14px;
  margin-right: 10px;
`;

const VideoTagsBlock = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
`;

const SubmitButton = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/Components/Videos/ChangeVideosList/ChangeTemplateVidoes.jsx